import type { HelpFile } from '../../types/help'
import { InlineAttributeEditorTestIds } from '../../../testids/InlineAttributeEditorTestIds'

export const inlineAttributeEditorHelp: HelpFile = {
  docPage: '/docs/admin/attribute-definitions',
  texts: {
    [InlineAttributeEditorTestIds.inlineAttributeEditor]: 'Attributwerte direkt an der Entität bearbeiten — Änderungen werden je Attribut nach Bestätigung gespeichert.',
    [InlineAttributeEditorTestIds.inlineAttributeEditorRetry]: 'Attributdefinitionen konnten nicht geladen werden — erneut versuchen.',
    [InlineAttributeEditorTestIds.referenceLink]: null,
  },
}
